module.exports = __webpack_public_path__ + "static/img/title.25f41176.png";